// Note (DaBi): Having this internmediate file dedicated to exporting asynchronously
//   loaded variables outside async functions allowes for easier mocking during testing

import { getFormats, getLang, getMessagesForAllProjects } from "./i18nDataBuilder";

export const locale = getLang();
export const formats = getFormats();
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
export const messagesForAllProjects = await getMessagesForAllProjects();
